export default {
    unassign_drivers_title: "Desasignar Conductores",
    unassign_drivers_account_from: "Account Origen",
    unassign_drivers_account_to: "Account Destino",
    unassign_drivers_keyfobs: "LLaveros",
    unassign_drivers_input: "ID#'s",
    unassign_drivers_identifier: "Identificador",
    unassign_drivers_account: "Cuenta",
    unassign_drivers_driver: "Conductor",
    unassign_drivers_model: "Modelo",
    unassign_drivers_change: "Desasignar",
    unassign_drivers_no_devices_added: "No se han añadido llaveros",
    unassign_drivers_device_is_already_added: "El dispositivo ya está desasignado",
    unassign_drivers_device_has_not_been_found: "No se ha encontrado el dispositivo",
    unassign_drivers_this_feature_is_not_available: "Esta función no está disponible",
    unassign_drivers_single_success_message: "se ha desasignado el llavero",
    unassign_drivers_multiple_success_message: "Se han desasignado los llaveros",
    unassign_drivers_error_message: "No se pueden desasignar los llaveros debido a un error",
    unassign_drivers_select_to_account: "Seleccione la cuenta de destino primero",
    unassign_drivers_restriction_to_move: "No se pueden desasignar los llaveros a cuentas que no están activas",
    unassign_drivers_confirm: "¿Desea desasignar los conductores de loa llaveros seleccionados?",
}